/* MICAVO REFILL-UPSELL IM WARENKORB
 * ---------------------------------------------------------------------------
 * Klick-Handler fuer die "+ Hinzufuegen"-Buttons aus snippets/mvq-cart-upsell.liquid.
 *
 * Ablauf:
 *   1. POST /cart/add.js mit der Varianten-ID aus data-mvq-add
 *   2. Impact-Theme neu rendern lassen: CustomEvent 'cart:refresh' auf
 *      document.documentElement (dokumentiertes Theme-Event) -> Drawer,
 *      Free-Shipping-Bar, Zaehler usw. aktualisieren sich selbst.
 *   3. Auf der /cart-Seite (Section main-cart) wird stattdessen neu geladen.
 *   4. Fallback: kommt binnen 2,5 s kein 'cart:change' vom Theme, Seite neu laden.
 *
 * Delegierter Listener auf document, damit er auch nach einem Re-Render des
 * Drawer-Inhalts weiter funktioniert (Inline-Skripte wuerden dabei sterben).
 * Eingebunden in: layout/theme.liquid (global, defer).
 */
(function () {
  'use strict';

  if (window.__mvqUpsell) return;
  window.__mvqUpsell = true;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mvq-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();

    var id = parseInt(btn.getAttribute('data-mvq-add'), 10);
    if (!id) return;

    var onCartPage = !!btn.closest('.shopify-section--main-cart');

    btn.disabled = true;
    btn.textContent = 'Wird hinzugefügt…';

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart/add failed: ' + r.status);
        return r.json();
      })
      .then(function () {
        if (onCartPage) {
          window.location.reload();
          return;
        }

        var refreshed = false;
        var onChange = function () { refreshed = true; };
        document.addEventListener('cart:change', onChange, { once: true });

        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', { bubbles: true })
        );

        window.setTimeout(function () {
          document.removeEventListener('cart:change', onChange);
          if (!refreshed) window.location.reload();
        }, 2500);
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = '+ Hinzufügen';
      });
  }, false);
})();
